<template>
    <v-card flat class="pa-5">
        <v-menu
            :close-on-content-click="false"
            v-model="datepicker"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
        >
            <v-text-field
              slot="activator"
              v-model="expenseInvoiceDate"
              label="Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker 
              v-model="expenseInvoiceDate"
              @input="datepicker = false"
            />
        </v-menu>

        <v-select 
            v-model="selectedFirmFromExpense"
            :items="firmsByBrand"
            label="From Firm"
            item-value="value"
            required
        />
       
            <v-select 
                v-bind:items="expenseByBrand"
                v-model="selectExpense" 
                label="Select or add Expense"
                autocomplete
                @keyup.native.enter="addExpense"
            />

            <span class="error--text" v-if="addError">{{addError}}</span>

        <v-select
            v-if="selectExpense"
            :disabled="!!selectedExpenseType.category"
            v-bind:items="categotyList"
            v-model="expenseCategory" 
            label="Select Expense Category"
        />
        <v-select 
            v-if="selectExpense && expenseCategory"
            :disabled="!!selectedExpenseType.underHead"
            v-bind:items="underHeadList"
            v-model="expenseUnderHead" 
            label="Select UnderHead"
        />

        <div v-if="(selectExpense && selectedFirm && selectedFirm.firm['GST_user'] != 'No') && (!firmExpense.length || !(firmExpense.length && firmExpense[0] && firmExpense[0].isGSTApplicable != false))">
                <b class="subheading primary--text font-weight-bold"> IS GST Applicable Over this Expense? </b> 
            </div>
            <v-radio-group 
                v-model="isGSTApplicable" 
                row 
                :disabled="!!(firmExpense.length && firmExpense[0] && selectExpense)"
                v-if="(selectExpense && selectedFirm && selectedFirm.firm['GST_user'] != 'No') && (!firmExpense.length || !(firmExpense.length && firmExpense[0] && firmExpense[0].isGSTApplicable != false))">
                    <v-radio label="Yes" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>

            <v-select
                dense
                :items="[3,5,12,18,28]"
                v-model="taxableGST_rate"
                :disabled="!!(firmExpense.length && firmExpense[0] && taxableGST_rate)"
                v-if="isGSTApplicable && selectExpense"
                label="Taxable GST rate"
            ></v-select>

              <v-select
                dense
                v-if="isGSTApplicable && selectExpense"
                :items="GST_types_list"
                 :disabled="!!(firmExpense.length && firmExpense[0] && GST_type)"
                label="Select GST type"
                v-model="GST_type"
            ></v-select>

            <div v-if="isGSTApplicable && selectExpense">
                <b class="subheading primary--text font-weight-bold">Does RCM Applicable ? </b> 
            </div>
            <v-radio-group 
                v-model="isRCMApplicable" 
                row 
                :disabled="!!(firmExpense.length && firmExpense[0] && isRCMApplicable != null)"
                v-if="isGSTApplicable && selectExpense">
                    <v-radio label="Yes" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
      
        <div v-if="selectExpense && expenseCategory && expenseUnderHead && (!firmExpense.length) && !selectedFirmOpeningBalance">
            <b class="subheading primary--text font-weight-bold"> Is Opening Balance Available For </b> 
        </div>
        <v-radio-group 
            v-model="isOpeningBalance" 
            row 
            v-if="selectExpense && expenseCategory && expenseUnderHead && (!firmExpense.length)">
                <v-radio label="Yes" :value="true"></v-radio>
                <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
            
            <v-text-field 
                type="number"
                v-if="(selectExpense && expenseCategory && expenseUnderHead && isOpeningBalance && !firmExpense.length) && !selectedFirmOpeningBalance"
                label="Opening Balance" 
                v-model="expenseOpeningBalance">
            </v-text-field>

            <b v-if="selectExpense && expenseCategory  && expenseOpeningBalance && isOpeningBalance" class="subheading primary--text font-weight-bold"> Payment Type </b>
            <v-radio-group
                v-if="selectExpense && expenseCategory  && expenseOpeningBalance && isOpeningBalance" 
                v-model="expenseVia"  
                :mandatory="false" 
            row>
                <!-- <v-radio label="From Cash" value="cash"></v-radio>
                <v-radio label="From Bank Account" value="account"></v-radio> -->
                <v-radio label="From Provision" value="provision"></v-radio>
            </v-radio-group>

            <v-text-field 
                label="Taxable Value" 
                type="number"
                v-model="taxableAmount" 
                @keyup="expenseAmount = (Number.parseFloat(taxableAmount) + Number.parseFloat((taxableAmount*taxableGST_rate)/100))"
                v-if="selectExpense && isGSTApplicable && !isOpeningBalance && isRCMApplicable !=null"
            >
            </v-text-field>

            <v-text-field 
                label="GST Value" 
                :value="((taxableAmount*taxableGST_rate)/100)" 
                v-if="selectExpense && isGSTApplicable && !isOpeningBalance  && isRCMApplicable !=null"
                :disabled="true"
            >
            </v-text-field>

            <v-text-field 
                label="Amount" 
                v-model="expenseAmount"
                :hint="hintText"
                v-if="selectExpense && expenseCategory && expenseUnderHead && !isOpeningBalance"
                required>
            </v-text-field>

            <b v-if="selectExpense && expenseCategory && expenseUnderHead && expenseAmount && !isOpeningBalance" class="subheading primary--text font-weight-bold"> Payment Type </b>

            <v-radio-group
                v-if="selectExpense && expenseCategory && expenseUnderHead && expenseAmount && !isOpeningBalance" 
                v-model="expenseVia"  
                :mandatory="false" 
            row>
                <v-radio label="From Cash" value="cash"></v-radio>
                <v-radio label="From Bank Account" value="account"></v-radio>
                <v-radio label="From Provision" value="provision"></v-radio>
                <v-radio label="From Capital" value="capital"></v-radio>
            </v-radio-group>
              <v-select 
                v-if="expenseVia == 'account'" 
                    v-model="selectAccountFromExpense"
                    :items="banksByFirm"
                    label="From Account"
                    :disabled="!selectedFirmFromExpense"
                    required
                >
                <template slot="selection" slot-scope="data">
                    {{ data.item.account.accountnumber }}{{data.item.account.bankName ? ' | '+data.item.account.bankName : '' }}
                </template>
                <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                        <v-list-tile-title v-html="`${data.item.account.accountnumber}
                            ${data.item.account.bankName ? ' | '+data.item.account.bankName : '' }
                            ${data.item.account.accountType ? ' | '+data.item.account.accountType : '' }
                            | ₹: ${(data.item.account.amount || 0).toLocaleString()}`
                        " />
                    </v-list-tile-content>
                </template>
            </v-select>
            <v-text-field 
                label="Remark" 
                v-model="expenseRemark"
                v-if="selectExpense  && expenseCategory && expenseUnderHead && (expenseAmount || expenseOpeningBalance)"
                :disabled="!!selectedExpenseType.expenseRemark" >
            </v-text-field>
            
            <v-btn color="primary" @click="expenseAmountClick">
            <v-icon dark>money_off</v-icon> &nbsp; Save
            </v-btn>
            
            <v-btn color="primary" @click="$router.go(-1)">
            <v-icon dark>cancel</v-icon> &nbsp; Cancel 
            </v-btn>

            <v-btn round outline class="primary--text font-weight-bold" @click="openExpenseTable = true">
                <v-icon dark> remove_red_eye </v-icon> 
                  &nbsp;  Expense Table 
            </v-btn>
            <v-btn round outline class="primary--text font-weight-bold" @click="openProvisionTable = true">
                <v-icon dark> remove_red_eye </v-icon> 
                  &nbsp;  Provision Table 
            </v-btn>
                <v-dialog
                    fullScreen
                    v-model="openExpenseTable"
                    transition="dialog-bottom-transition"
                >
                    <v-toolbar card dark color="primary">
                        <v-toolbar-title>Expense Details</v-toolbar-title>
                        <v-spacer/>
                        <v-btn icon dark @click.native="openExpenseTable = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card>
                        <Expense-table-info :accountsByBrand="accountsByBrand" :firmsByBrand="firmsByBrand" />
                    </v-card>
                </v-dialog>
                <v-dialog
                    fullScreen
                    v-model="openProvisionTable"
                    transition="dialog-bottom-transition"
                >
                    <v-toolbar card dark color="primary">
                         <v-flex xs12 md3>
                            <v-select
                                class="select-firm"
                                :items="firmsByBrand"
                                label="Select Firm"
                                v-model="selectedFirmProvisionFilter"
                            ></v-select>
                            </v-flex>
                              <v-flex xs12 md3>
                                <h3>
                                    <p style="text-align: center;"> <v-toolbar-title>Provision Details</v-toolbar-title></p>
                                </h3>
                                </v-flex>   
                        <v-spacer/>
                        <v-btn icon dark @click.native="openProvisionTable = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card>
                        <v-data-table :items="provisionByBrand" class="elevation" :headers="provisionHeader">
                            <template slot="items" slot-scope="props">
                            <td>{{ props.item['.key'] }}</td>
                            <td><b class="font-weight-bold">{{ getFirmName(props.item.firm) }}</b></td>
                            <td>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</td>
                            <td>{{ props.item.openingBalance || 0 | amount }}</td>
                            <td v-if="!props.item['isCredited']">
                                <b  class="success--text font-weight-bold">{{ props.item.credit || 0 | amount }}</b>
                            </td>
                            <td v-else></td>
                            <td v-if="props.item['isCredited']" >
                                 <b class="error--text font-weight-bold">{{ props.item.debit || 0 | amount }}</b>
                            </td>
                             <td v-else></td>
                             <td>
                                 <b >{{ props.item.RunningBal || 0 | amount }}</b>
                            </td>
                            <!-- <td>{{ getTotalAmount(props.item)|| 0 | amount }}</td> -->
                            <td>{{ ((props.item.openingBalance ?  props.item.totalAmount : 0 ) + (props.item.totalAmount ? props.item.totalAmount : 0) ) || 0| amount }}</td>
                            <td>{{ props.item.paymentType }}</td>
                            <td>{{ props.item.remark}}</td>
                            <td><b>{{ props.item.paymentTypeStatus || "yet to confirm/confirm" }}</b></td>
                            </template>
                            <template slot="no-data">no record found</template>
                         </v-data-table>
                    </v-card>
                </v-dialog>
            </v-card>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];

import ExpenseTableInfo from '../table/expenseTable.vue';
import {digitsToWords} from '../../../utils/digitsToWords.js'

export default {
    name: 'ExpenseTab',
    props: {
        selectedBrand: { type: String },
        accountsByBrand: { type: Array },
        firmsByBrand: { type: Array },
    },
    components: {
        ExpenseTableInfo
    },
    data() {
        return {
            openExpenseTable: false,
            openProvisionTable : false,
            datepicker: false,
            hintText : null,
            selectedFirm : this.firmsByBrand[0].value,
            selectedFirmFromExpense:this.firmsByBrand[0].value,
            isOpeningBalance : null,
            isGSTApplicable:null,
            taxableGST_rate:null,
            GST_type : null,
            isRCMApplicable : null,
            taxableAmount : null,
            GST_types_list:['CGST|SGST','IGST'],
            // GST_types_list:['IGST','SGST|CGST'],
            selectAccountFromExpense:null,
            categotyList: ['Direct', 'Indirect'],
            underHeadList: ['Prop Capital A/C', 'Profit and Loss'],
            expenseInvoiceDate: null,
            expenseVia: 'cash',
            addError : null,
            selectExpense: null,
            expenseCategory: null,
            expenseUnderHead: null,
            expenseOpeningBalance: null,
            expenseRemark: null,
            expenseAmount: null,
            selectedFirmOpeningBalance : null,
            firmExpense : [],
            selectedFirmProvisionFilter : null,
            provisionHeader : [
                { text: "Id", value: ".key", sortable: false },
                { text: "Firm Name", value: "firm", sortable: true },
                { text: "Date", value: "expense", sortable: true },
                { text: "Opening WDV", value: "openingBalance", sortable: false },
                { text: "Credit", value: "totalAmount", sortable: false },
                { text: "Debit", value: "totalAmount", sortable: false },
                { text: "Running Balance", value: "totalAmount", sortable: false },
                { text: "Closing WDV", sortable: false },
                { text: "paymentType", value: ".key", sortable: false },
                { text: "remark", value: "type", sortable: true },
                { text: "paymentTypeStatus", value: "paymentTypeStatus", sortable: false },
            ],
        }
    },
    created() {
        this.$bindAsArray('provisionExpense', this.$root.$firebaseRefs.provisionExpense.orderByChild('brand').equalTo(this.selectedBrand)),
        this.$bindAsArray('banks', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)),
        this.$bindAsArray("firmList", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)),
        this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand)),
        this.$bindAsArray("expenses", this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
        let today = new Date()
        this.expenseInvoiceDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
    },
    computed: {
        ...mapGlobalGetters(["brandFinYear"]),
        expenseByBrand() {
            return this.expenses.filter((item) =>
            item['brand'] === this.selectedBrand
            ).map(item =>{
                return{
                    expense: item,
                    text : item['expense'],
                    value: item['.key']
                }
            })
        },
        banksByFirm(){
            return this.banks.filter((item) => 
                item['brand'] === this.selectedBrand 
                && item['firm'] == this.selectedFirmFromExpense
            ).map(item => {
            return {
                account: item,
                text: item['accountnumber'],
                value: item['.key']
            }
            })
        },
        provisionByBrand() {
            let provision =  this.provisionExpense.filter((item) =>
            item['brand'] === this.selectedBrand && 
             ( this.selectedFirmProvisionFilter ? this.selectedFirmProvisionFilter === item["firm"] : true)
            )
            provision.map((p,index)=>{
                if(p.isCredited) {
                    provision[index]["debit"] = provision[index]["totalAmount"]
                    provision[index]["credit"] = 0
                } else {
                    provision[index]["credit"] = provision[index]["totalAmount"]
                    provision[index]["debit"] = 0
                }
                provision[index]["RunningBal"] =
                Number.parseFloat(provision[index]["debit"]) -
                Number.parseFloat(provision[index]["credit"]) +
                (index == 0 ? 0 :  Number.parseFloat(provision[index]["RunningBal"]));
                    });
            return provision;
        },
        selectedExpenseType() {
            if(this.selectExpense) {
                const expense = this.expenses.find(item => item['.key'] === this.selectExpense);
                this.expenseUnderHead = expense.underHead;
                this.expenseCategory = expense.category;
                return expense
            }
            return {}
        }
    },
    watch: {
            "selectedFirmFromExpense": {
                handler(newVal, oldVal) {
                    if(newVal != oldVal) {
                    // let firm = this.firmList.filter(item => item[".key"] === newVal)[0];  
                    // this.selectedFirmOpeningBalance = firm.openingBalance
                    this.getFirmExpense();
                    }
                },
                deep: true
            },
            "selectExpense": {
                handler(newVal, oldVal) {
                    if(newVal != oldVal) {
                    this.getFirmExpense();
                    }
                },
                deep: true
            },
            "expenseAmount" : {
                handler(){
                    this.hintText = this.expenseAmount ? _.startCase(digitsToWords(Number.parseFloat(this.expenseAmount))) : null
                },
                deep : true
            },
    },
    methods: {
        getFirmExpense(){
            this.selectedFirm = this.firmsByBrand.filter(item => item['value'] == this.selectedFirmFromExpense)[0]
            console.log(this.selectedFirm)
            let firmExpense = this.invoices.filter(item => (item["firm"] === this.selectedFirmFromExpense && item["expenseType"] === this.selectExpense))
            this.firmExpense = firmExpense;
            let openingBalance = 0;
            firmExpense.map((inv)=>{
                openingBalance += (inv.openingBalance ? parseInt(inv.openingBalance) : 0);
            });
            this.selectedFirmOpeningBalance = openingBalance;
            if(firmExpense.length && firmExpense[0].isGSTApplicable) {
                this.isGSTApplicable = firmExpense[0].isGSTApplicable;
            }
            if(firmExpense.length && firmExpense[0].taxableGST_rate) {
                this.taxableGST_rate = firmExpense[0].taxableGST_rate;
            }
            if(firmExpense.length && firmExpense[0].GST_type) {
                this.GST_type = firmExpense[0].GST_type;
            }
            if(firmExpense.length &&  firmExpense[0].isRCMApplicable) {
                this.isRCMApplicable = firmExpense[0].isRCMApplicable;
            }
        },
         getFirmName(e){
          let firm;
          if (this.firmList && this.selectedBrand) {
            firm =this.firmList.filter(item => item['.key'] === e)[0]
          }
          if(firm)
          return firm.name
        },
        reset() {
            this.expenseAmount = null;
            this.selectedFirmFromExpense = null;
            this.selectAccountFromExpense = null;
            this.expenseRemark = null;
            this.selectExpense = null;
            this.expenseVia = null;
            this.expenseCategory = null;
            this.expenseUnderHead = null;
            this.expenseOpeningBalance = null;
            // this.GST_type = '';
            this.GST_types_list = ['CGST|SGST','IGST'];
            this.taxableGST_rate = null;
            this.taxableAmount = null;
            let today = new Date()
            this.expenseInvoiceDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`;
            this.firmExpense = [];
            this.selectedFirmOpeningBalance = null;
            this.$emit('closedialog');
        },
        expenseAmountClick:function(e){
            if(this.expenseRemark !=null) {
                if(this.selectExpense != null) {
                    // expenseData updated with category and underhead on expense create
                    if(this.expenseCategory !== this.selectedExpenseType.category || this.expenseUnderHead !== this.selectedExpenseType.underHead) {
                        this.$root.$firebaseRefs.expenses.child(this.selectExpense).update({
                            category: this.expenseCategory,
                            underHead: this.expenseUnderHead
                        })
                    }
                    if(this.expenseVia == 'cash'){
                        // let expenseAmount = Number.parseFloat(this.isGSTApplicable && this.isRCMApplicable ? this.taxableAmount : ((this.isGSTApplicable && !this.isRCMApplicable) ? (this.taxableAmount+ ((this.taxableAmount* this.taxableGST_rate)/100)) :this.expenseAmount));
                        let expenseAmount = this.isGSTApplicable && this.isRCMApplicable ? Number.parseFloat(this.taxableAmount) : ((this.isGSTApplicable && !this.isRCMApplicable) ? (Number.parseFloat(this.taxableAmount)+ ((Number.parseFloat(this.taxableAmount)* this.taxableGST_rate)/100)) :Number.parseFloat(this.expenseAmount));
                        this.$root.$firebaseRefs.firm.child(this.selectedFirmFromExpense).once('value').then((snap) => {
                            if(Number(snap.val().amount) >= expenseAmount){
                                this.$root.$firebaseRefs.firm.child(this.selectedFirmFromExpense).update({
                                    amount: Number(snap.val().amount) - Number(expenseAmount)
                                });
                                setTimeout(() => {
                                    this.addInvoiceExpense({
                                        expenseVia: this.expenseVia,
                                        expenseType: this.selectExpense,
                                        firmOfExpense: this.selectedFirmFromExpense,
                                        expenseAmount: this.expenseAmount,
                                        expenseRemark: this.expenseRemark,
                                        openingBalance : this.expenseOpeningBalance
                                    })
                                })
                            } else{
                                this.$emit('notify','Insufficient Balance')
                            }
                        })
                    } else if(this.expenseVia == 'account') {
                        let expenseAccountFirm= null;
                        let expenseAccountNumber =null;
                        // let expenseAmount = this.isGSTApplicable && this.isRCMApplicable ? this.taxableAmount : ((this.isGSTApplicable && !this.isRCMApplicable) ? (this.taxableAmount+ ((this.taxableAmount* this.taxableGST_rate)/100)) :this.expenseAmount);
                        let expenseAmount = this.isGSTApplicable && this.isRCMApplicable ? Number.parseFloat(this.taxableAmount) : ((this.isGSTApplicable && !this.isRCMApplicable) ? (Number.parseFloat(this.taxableAmount)+ ((Number.parseFloat(this.taxableAmount)* this.taxableGST_rate)/100)) :Number.parseFloat(this.expenseAmount));
                        this.$root.$firebaseRefs.account.child(this.selectAccountFromExpense).once('value').then(snap => {
                            expenseAccountFirm = snap.val().firm;
                            expenseAccountNumber = snap.val().accountnumber;
                            if(Number(snap.val().amount) >= expenseAmount){
                                this.$root.$firebaseRefs.account.child(this.selectAccountFromExpense).update({
                                    amount: Number(snap.val().amount) - Number(expenseAmount)
                                });
                                this.$emit('notify', "expense amount paid", true);
                                setTimeout(() => {
                                    this.addInvoiceExpense({
                                        expenseVia: this.expenseVia,
                                        expenseType: this.selectExpense,
                                        firmOfExpense: expenseAccountFirm, 
                                        expenseAmount: this.expenseAmount,
                                        expenseRemark: this.expenseRemark,
                                        accountOfExpense: expenseAccountNumber,
                                        openingBalance : this.expenseOpeningBalance,
                                    })
                                })
                            } else{
                                this.$emit('notify','Insufficient Balance')
                            }
                        })
                    } else {
                        this.addInvoiceExpense({
                            expenseVia: this.expenseVia,
                            expenseType: this.selectExpense,
                            firmOfExpense: this.selectedFirmFromExpense, 
                            expenseAmount: this.expenseAmount,
                            expenseRemark: this.expenseRemark,
                            openingBalance : this.expenseOpeningBalance
                        })  
                    }
                } else {
                    this.$emit('notify','Please enter a expense type')
                }
            } else {
                this.$emit('notify','Please enter a remark')
            }
        },
        addExpense:function(e){
            let expenseData = {
                brand: this.selectedBrand,
                expense: e.target.value,
                category: null,
                underHead: null,
            }
            let availableExpensis = this.expenses.filter(item => item.expense ==  e.target.value && item['brand'] === this.selectedBrand);
            if(availableExpensis.length) {
                this.addError = 'Expense with name ' + e.target.value + ' Already exist.';
                setTimeout(() => {
                    this.addError = null;
                }, 3000);
            } else {
                this.$root.$firebaseRefs.expenses.push(expenseData);
            }
            // push expense without category and underhead
            
        },
        // Expense Invoice
        addInvoiceExpense({ expenseVia, expenseType, firmOfExpense, expenseAmount, expenseRemark, accountOfExpense,openingBalance}) {
            if(expenseVia == 'cash'){
                let invoiceViaCash = {
                    brand: this.selectedBrand,
                    brandFinYear : this.brandFinYear,
                    type:'automatic invoice',
                    transactionType: 'Expense',
                    firm:firmOfExpense,
                    paymentType:expenseVia,
                    accountNumber:'',
                    paymentTypeStatus : 'confirm',
                    isCredited:false,
                    totalAmount:Number(expenseAmount),
                    remark:expenseRemark,
                    expenseType:expenseType,
                    openingBalance : openingBalance,
                    date: this.expenseInvoiceDate ? Date.parse(this.expenseInvoiceDate) : Date.now(),
                }

                if(this.isGSTApplicable) {
                    invoiceViaCash['isGSTApplicable'] = this.isGSTApplicable;
                }

                if(this.taxableGST_rate) {
                    invoiceViaCash['taxableGST_rate'] = this.taxableGST_rate;
                }

                if(this.GST_type) {
                    invoiceViaCash['GST_type'] = this.GST_type;
                }

                if(this.isRCMApplicable) {
                    invoiceViaCash['isRCMApplicable'] = this.isRCMApplicable;
                }

                if(this.taxableAmount) {
                    invoiceViaCash['taxableAmount'] = this.taxableAmount;
                }
                this.$root.$firebaseRefs.invoice.push(invoiceViaCash, () => {
                    this.$emit('notify', "expense amount paid", true);
                    this.reset();
                });
            } else if(expenseVia == 'account') {
                let invoiceViaAccount = {
                    brand: this.selectedBrand,
                    brandFinYear : this.brandFinYear,
                    type:'automatic invoice',
                    transactionType: 'Expense',
                    firm:firmOfExpense,
                    paymentType:expenseVia,
                    accountNumber:accountOfExpense,
                    isCredited:false,
                    bank : this.selectAccountFromExpense,
                    paymentTypeStatus : 'confirm',
                    totalAmount:Number(expenseAmount),
                    remark:expenseRemark,
                    expenseType:expenseType,
                    openingBalance : openingBalance,
                    date: this.expenseInvoiceDate ? Date.parse(this.expenseInvoiceDate) : Date.now()
                }

                if(this.isGSTApplicable) {
                    invoiceViaAccount['isGSTApplicable'] = this.isGSTApplicable;
                }

                if(this.taxableGST_rate) {
                    invoiceViaAccount['taxableGST_rate'] = this.taxableGST_rate;
                }

                if(this.GST_type) {
                    invoiceViaAccount['GST_type'] = this.GST_type;
                }

                if(this.isRCMApplicable) {
                    invoiceViaAccount['isRCMApplicable'] = this.isRCMApplicable;
                }

                if(this.taxableAmount) {
                    invoiceViaAccount['taxableAmount'] = this.taxableAmount;
                }
                this.$root.$firebaseRefs.invoice.push(invoiceViaAccount, () => {
                    this.$emit('notify', "expense amount paid", true);
                    this.reset();
                });
            } else {
                 let invoiceViaAccount = {
                    brand: this.selectedBrand,
                    brandFinYear : this.brandFinYear,
                    type:'automatic invoice',
                    transactionType: 'Expense',
                    firm:firmOfExpense,
                    paymentType:expenseVia,
                    accountNumber:'',
                    isCredited:false,
                    paymentTypeStatus : 'yet to confirm',
                    totalAmount:Number(expenseAmount),
                    remark:expenseRemark,
                    expenseType:expenseType,
                    openingBalance : openingBalance,
                    date: this.expenseInvoiceDate ? Date.parse(this.expenseInvoiceDate) : Date.now()
                }

                if(this.isGSTApplicable) {
                    invoiceViaAccount['isGSTApplicable'] = this.isGSTApplicable;
                }

                if(this.taxableGST_rate) {
                    invoiceViaAccount['taxableGST_rate'] = this.taxableGST_rate;
                }

                if(this.GST_type) {
                    invoiceViaAccount['GST_type'] = this.GST_type;
                }

                if(this.isRCMApplicable) {
                    invoiceViaAccount['isRCMApplicable'] = this.isRCMApplicable;
                }

                if(this.taxableAmount) {
                    invoiceViaAccount['taxableAmount'] = this.taxableAmount;
                }
                let res = this.$root.$firebaseRefs.invoice.push(invoiceViaAccount)
                console.log(res)
                if(res.key) {
                    invoiceViaAccount['invoiceId'] = res.key
                    this.$root.$firebaseRefs.provisionExpense.push(invoiceViaAccount, () => {
                        this.$emit('notify', "expense amount paid", true);
                        this.reset();
                    });
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/InvoiceManagement/tabs/expense.vue